var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-gender"},[_c('span',[_vm._v(_vm._s(_vm.gender === 0 ? 'Nữ' : 'Nam'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }